import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const PerfilTaxaImpostoPageController = () => {
  //estados globais
    const perfilTaxaImpostoState = useAppSelector((state) => state.perfilTaxaImposto);
  

  const Page = pages[perfilTaxaImpostoState.page];

  return <Page key={perfilTaxaImpostoState.page} />;
};

export default PerfilTaxaImpostoPageController;
